import { CuriosityNamespaceType, useCuriosityTranslation } from '@procureai/curiosity-ui-mui';
import { isNil, isNotNil } from 'ramda';

import { DemandDocument, DemandDocumentListItem } from '../../DemandDocument.types';

export const useDemandDocument = (file: DemandDocument): DemandDocumentListItem => {
  const { ct } = useCuriosityTranslation(CuriosityNamespaceType.FILE);
  const label = ct(file.id)?.value;

  // Show the negotiation case link if the file is associated with a negotiation case
  const negotiationCase =
    isNotNil(file.negotiationCaseId) && isNotNil(file.negotiationCaseSequence)
      ? { id: file.negotiationCaseId, sequenceNumber: file.negotiationCaseSequence }
      : undefined;

  // Show the analyse quote button if the file is not associated with a quote and not shared with a supplier
  const isAnalysisEligible = !!(
    label && // if we can't resolve the name, the user doesn't know what file to analyse
    isNil(file.quoteId) &&
    !negotiationCase &&
    !file.isSharedWithSupplier &&
    label.toLowerCase().endsWith('.pdf')
  );

  return {
    id: file.id,
    label,
    isAnalysisEligible,
    negotiationCase,
    isSharedWithSupplier: file.isSharedWithSupplier,
  };
};
